/**
 * O e-mail de redefinição do KTIdentity usa rota em hash: {origem}/#/recuperar-senha/{code}/{token}.
 * Este app usa rotas por caminho, então o link cairia na raiz. Antes do bootstrap, reescreve
 * esse padrão exato para /recuperar-senha/{code}/{token}, sempre no próprio site.
 * Devolve o caminho reescrito, ou null quando o hash não é o do Identity.
 */
const RECOVERY_HASH = /^#\/recuperar-senha\/([^/?#\s]+)\/([^/?#\s]+)\/?$/;

export function ktidentityRecoveryPath(hash: string): string | null {
  const match = RECOVERY_HASH.exec(hash || '');
  if (!match) {
    return null;
  }
  const [, code, token] = match;
  if ([code, token].some(segment => /^\.+$/.test(segment))) {
    return null;
  }
  return `/recuperar-senha/${code}/${token}`;
}

export function redirectKtidentityRecoveryHash(location: Location, history: History): boolean {
  const path = ktidentityRecoveryPath(location.hash);
  if (!path) {
    return false;
  }
  history.replaceState(null, '', path);
  return true;
}
